import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-timer.tsx
/**
* icon.24.timer
*
* Keywords: stopwatch, time, chronometer, measurement, clock, sport, countdown, precision
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgNWEuNS41IDAgMCAwIDAgMWgxLjV2MS4wMmE2IDYgMCAxIDAgNS44NzUgMy4zMTJsLjI3MS0uMjcxYTEuNSAxLjUgMCAwIDAgMC0yLjEyMmwtLjU4NS0uNTg1YTEuNSAxLjUgMCAwIDAtMi4xMjIgMGwtLjI3LjI3YTYgNiAwIDAgMC0yLjE2OS0uNjAzVjZIMTRhLjUuNSAwIDAgMCAwLTF6bTUuNTQ3IDMuMTZjLjQ5NC4zNjMuOTMuOCAxLjI5MyAxLjI5M2wuMS0uMWEuNS41IDAgMCAwIDAtLjcwN2wtLjU4Ni0uNTg1YS41LjUgMCAwIDAtLjcwOCAwek0xMiA4YTUgNSAwIDEgMCAwIDEwIDUgNSAwIDAgMCAwLTEwbS41IDEuNWEuNS41IDAgMCAwLTEgMHYyLjYzNGExIDEgMCAxIDAgMSAweiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11198
*/
const Icon24Timer = memo(function Icon24Timer(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10 5a.5.5 0 0 0 0 1h1.5v1.02a6 6 0 1 0 5.875 3.312l.271-.271a1.5 1.5 0 0 0 0-2.122l-.585-.585a1.5 1.5 0 0 0-2.122 0l-.27.27a6 6 0 0 0-2.169-.603V6H14a.5.5 0 0 0 0-1zm5.547 3.16c.494.363.93.8 1.293 1.293l.1-.1a.5.5 0 0 0 0-.707l-.586-.585a.5.5 0 0 0-.708 0zM12 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10m.5 1.5a.5.5 0 0 0-1 0v2.634a1 1 0 1 0 1 0z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Timer };

//# sourceMappingURL=icon-24-timer.js.map